import { EmptyState } from '@/shared/components';
import { I } from '@/shared/icons';
import type { PropertiesEmptyKind } from '../usePropertiesList';

interface Props {
  kind: Exclude<PropertiesEmptyKind, null>;
  canEdit: boolean;
  onResetFilters: () => void;
  onCreate: () => void;
  onFirstPage: () => void;
}

/** Leer-, Filter- und Fehlerzustand der Apartmentliste — je eine reale nächste Aktion (§11). */
export function PropertiesEmptyState({
  kind,
  canEdit,
  onResetFilters,
  onCreate,
  onFirstPage,
}: Props) {
  if (kind === 'error') {
    return (
      <EmptyState
        icon="Error"
        title="Apartments konnten nicht geladen werden"
        description="Bitte prüfen Sie Ihre Verbindung und laden Sie die Seite neu."
      />
    );
  }
  if (kind === 'pageEmpty') {
    return (
      <EmptyState
        icon="Building"
        title="Diese Seite ist leer"
        description="Auf dieser Seite steht kein Apartment mehr — vermutlich hat sich der Bestand seit dem Aufruf des Links geändert."
        action={{
          label: 'Zur ersten Seite',
          leftIcon: <I name="ArrowLeft" size={14} />,
          onClick: onFirstPage,
        }}
      />
    );
  }
  if (kind === 'filtered') {
    return (
      <EmptyState
        icon="Search"
        title="Keine Treffer"
        description="Kein Apartment passt zu Suche und Filter dieser Ansicht."
        action={{
          label: 'Filter zurücksetzen',
          leftIcon: <I name="Refresh" size={14} />,
          onClick: onResetFilters,
        }}
      />
    );
  }
  return (
    <EmptyState
      icon="Building"
      title="Noch keine Apartments"
      description="Legen Sie Ihr erstes Apartment an — Standort, Apartment und Betrieb in drei Schritten."
      {...(canEdit
        ? {
            action: {
              label: 'Neues Apartment',
              leftIcon: <I name="Plus" size={14} />,
              onClick: onCreate,
            },
          }
        : {})}
    />
  );
}
